// Load Board V1 — Web (THT-695). Device-local date helpers for the coverage
// options: `coverage_date` is computed in the browser's local timezone so it
// matches what the dispatcher sees in the request email. Implemented with plain
// `Date` (no date-fns subpath dependency) so nothing round-trips through UTC —
// `new Date('yyyy-mm-dd')` parses as UTC midnight, which is exactly the trap
// these helpers exist to avoid.

/** Local-midnight copy of a date, shifted by `days` (handles month/year rollover). */
export const addDaysLocal = (date: Date, days: number): Date => {
  const copy = new Date(date);
  copy.setDate(copy.getDate() + days);
  return copy;
};

/** ISO `yyyy-mm-dd` of the device-local calendar day (NOT UTC). */
export const toIsoDateLocal = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/** Parse ISO `yyyy-mm-dd` as a device-local date (`new Date('yyyy-mm-dd')` is UTC). */
export const parseIsoDateLocal = (iso: string): Date => {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/** Human display (`Mon, Jul 13`) for an ISO `yyyy-mm-dd` coverage date. */
export const formatCoverageDate = (iso: string): string =>
  parseIsoDateLocal(iso).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
